import React, { Component } from "react";
import {
  Grid,
  Row,
  Col,
  FormGroup,
  FormControl,
  ControlLabel
} from "react-bootstrap";

import Card from "../../components/Card/Card.jsx";
import Button from "../../elements/CustomButton/CustomButton.jsx";

import Select from "react-select";
import "react-select/dist/react-select.css";
import SweetAlert from "react-bootstrap-sweetalert";

import UserService from "../../services/UserService";
import IncubationService from "../../services/IncubationService";

class Edit extends Component {
  constructor(props) {
    super(props);
    //this.vForm = this.refs.vForm;
    this.action = this.props.match.params.number ? "edit" : "create";
    this.userid = parseInt(this.props.match.params.number, 10);
    this.state = {
      alert: null,
      // Register
      username: "",
      email: "",
      password: "",
      cfpassword: "",
      usernameError: this.action === 'create' ? true : null,
      emailError: this.action === 'create' ? true : null,
      passwordError: this.action === 'create' ? true : null,
      cfpasswordError: this.action === 'create' ? true : null,
      rolesSelected: [],
      selectedProject: '',
      rolesError: this.action === 'create' ? true : null,
      proyectosError: this.action === 'create' ? true : null,
      rolesList: [],
      proyectos: [],
    };
    this.userService = new UserService();
    this.incubationService = new IncubationService();
    this.errorAlert = this.errorAlert.bind(this);
  }

  componentDidMount() {
    this.populateRoles();
    this.getProjects();
    if (this.action === "edit") {
      this.populateUser();
    }
  }

  getProjects() {
    this.incubationService
      .getCoordinadorTabData()
      .then(res => {
        const selectProyects = [];
        res.coordinador.data.forEach((proyecto) => {
          selectProyects.push({value: proyecto.idproyectoincubacion, label: proyecto.nombreproyecto});
        });
        this.setState({ proyectos: selectProyects });
      })
      .catch(err => {
        console.log(err);
        this.errorAlert((<div>Ha ocurrido un error mientras se obtenian los proyectos, el servidor ha devuelto la siguiente información: <p>{err.message}</p></div>));
      });
  }

  hideAlert() {
    this.setState({
        alert: null
    });
  }
  errorAlert(message) {
    this.setState({
      alert: (
        <SweetAlert
          error
          style={{ display: "block", marginTop: "-100px" }}
          title="Error"
          onConfirm={() => this.hideAlert()}
          onCancel={() => this.hideAlert()}
          confirmBtnBsStyle="danger"
          confirmBtnText="Aceptar"
        >
          {message}
        </SweetAlert>
      )
    });
  }
  populateRoles() {
    this.userService
      .getRoles()
      .then(res => {
        var roles = res.roles.map(function(rol) {
          return { value: rol.id, label: rol.rolename };
        });
        this.setState({ rolesList: roles });
      })
      .catch(err => {
        console.log(err);
        this.errorAlert((<div>Ha ocurrido un error mientras se obtenian los roles, el servidor ha devuelto la siguiente información: <p>{err.message}</p></div>));
      });
  }
  populateUser() {
    this.userService
      .getUser(this.userid)
      .then(res => {
        console.log(res.user);
        this.setState({
          username: res.user.username,
          email: res.user.email,
          rolesSelected: res.user.roles,
          selectedProject: {value: res.user.proyecto, label: res.user.nombreproyecto},
        });
      })
      .catch(err => {
        console.log(err);
        this.errorAlert((<div>Ha ocurrido un error mientras se obtenian los datos del usuario, el servidor ha devuelto la siguiente información: <p>{err.message}</p></div>));
      });
  }
  handleUserNameChange(event) {
    this.setState({ username: event.target.value });
    event.target.value.length < 6
      ? this.setState({
          usernameError: (
            <small className="text-danger">
              El nombre de usuario debe ser de al menos 6 caracteres.
            </small>
          )
        })
      : this.setState({ usernameError: null });
  }
  handleEmailChange(event) {
    this.setState({ email: event.target.value });
    var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    re.test(event.target.value) === false
      ? this.setState({
          emailError: (
            <small className="text-danger">
              Email es requerido y el formato debe ser
              <i>usuario@dominio.com</i>.
            </small>
          )
        })
      : this.setState({ emailError: null });
  }
  handlePasswordChange(event) {
    this.setState({ password: event.target.value });
    event.target.value.length < 6
      ? this.setState({
          passwordError: (
            <small className="text-danger">
              La contraseña debe ser de al menos 6 caracteres.
            </small>
          )
        })
      : this.setState({ passwordError: null });
  }
  handleCfPasswordChange(event) {
    this.setState({ cfpassword: event.target.value });
    event.target.value !== this.state.password
      ? this.setState({
          cfpasswordError: (
            <small className="text-danger">Las contraseñas no coinciden.</small>
          )
        })
      : this.setState({ cfpasswordError: null });
  }
  handleRegisterSubmit() {
    var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    re.test(this.state.email) === false
      ? this.setState({
          emailError: (
            <small className="text-danger">
              Email es requerido y el formato debe ser
              <i>usuario@dominio.com</i>.
            </small>
          )
        })
      : this.setState({ emailError: null });
    if (this.action === "create") {
      this.state.password.length < 6
        ? this.setState({
            passwordError: (
              <small className="text-danger">
                La contraseña debe ser de al menos 6 caracteres.
              </small>
            )
          })
        : this.setState({ passwordError: null });
      this.state.cfpassword !== this.state.password
        ? this.setState({
            cfpasswordError: (
              <small className="text-danger">
                Las contraseñas no coinciden.
              </small>
            )
          })
        : this.setState({ cfpasswordError: null });
    } else {
      // edit
      if (this.state.password.length > 1) {
        // si ha escrito algo en el campo es que quiere cambiar el password
        // cambio de contraseña
        this.state.password.length < 6
          ? this.setState({
              passwordError: (
                <small className="text-danger">
                  La contraseña debe ser de al menos 6 caracteres.
                </small>
              )
            })
          : this.setState({ passwordError: null });
        this.state.cfpassword !== this.state.password
          ? this.setState({
              cfpasswordError: (
                <small className="text-danger">
                  Las contraseñas no coinciden.
                </small>
              )
            })
          : this.setState({ cfpasswordError: null });
      }
    }
    this.state.rolesSelected.length === 0
      ? this.setState({
          rolesError: (
            <small className="text-danger">Seleccione al menos un rol</small>
          )
        })
      : this.setState({ rolesError: null });
    this.state.username.length < 6
      ? this.setState({
          usernameError: (
            <small className="text-danger">
              El nombre de usuario debe ser de al menos 6 caracteres.
            </small>
          )
        })
      : this.setState({ usernameError: null });

    if (this.action === "create") {
      if (
        this.state.emailError == null &&
        this.state.passwordError == null &&
        this.state.cfpasswordError == null &&
        this.state.rolesError == null &&
        this.state.usernameError == null &&
        this.state.proyectosError == null
      ) {
        this.userService
          .createUser(
            this.state.username,
            this.state.email,
            this.state.rolesSelected,
            this.state.password,
            this.state.selectedProject,
          )
          .then(res => {
            this.props.history.push("/users-management");
            this.props.pushNotification('success', 'tc', 'pe-7s-check', (<div>Usuario creado satisfactoriamente!</div>), 10);
          })
          .catch(err => {
            console.log(err);
            this.errorAlert((<div>Ha ocurrido un error mientras se creaba el usuario, el servidor ha devuelto la siguiente información: <p>{err.message}</p></div>));
          });
      }
    } else {
      //edit
      if (
        this.state.emailError == null &&
        this.state.passwordError == null &&
        this.state.cfpasswordError == null &&
        this.state.rolesError == null &&
        this.state.usernameError == null &&
        this.state.proyectosError == null
      ) {
        this.userService
          .updateUser(
            this.userid,
            this.state.username,
            this.state.email,
            this.state.rolesSelected,
            this.state.password,
            this.state.selectedProject,
          )
          .then(res => {
            this.props.history.push("/users-management");
            this.props.pushNotification('success', 'tc', 'pe-7s-check', (<div>Usuario actualizado satisfactoriamente!</div>), 10);
          })
          .catch(err => {
            console.log(err);
            this.errorAlert((<div>Ha ocurrido un error mientras se actualizaban los datos del usuario, el servidor ha devuelto la siguiente información: <p>{err.message}</p></div>));
          });
      }
    }
  }
  handleRolesChange(selected) {
    var values = [];
    if (selected) {
      values.push(selected.value);
      if (selected.value === '6') {
        this.setState({ proyectosError: true, selectedProject: '' });
      } else {
        this.setState({ proyectosError: null, selectedProject: '' });
      }
    }
    this.setState({ rolesSelected: values });
    values.length === 0
      ? this.setState({
          rolesError: (
            <small className="text-danger">Seleccione un rol</small>
          )
        })
      : this.setState({ rolesError: null });
  }

  handleProyectChange(value) {
    this.setState({ selectedProject: value });
    !value || value.length === 0
      ? this.setState({
          proyectosError: (
            <small className="text-danger">Seleccione un proyecto</small>
          )
        })
      : this.setState({ proyectosError: null });
  }

  render() {
    const disabledButton = this.state.cfpasswordError || this.state.emailError || this.state.passwordError || this.state.rolesError || this.state.usernameError || this.state.proyectosError ? true : false;

    return (
      <div className="main-content">
        {this.state.alert}
        <Grid fluid={true}>
          <Row>
            <Col md={12}>
              <form>
                <Card
                  title={
                    this.action === "edit"
                      ? "Edición de usuario"
                      : "Nuevo usuario"
                  }
                  content={
                    <div>
                      <FormGroup>
                        <ControlLabel>
                          Nombre de usuario:
                          <span className="star">*</span>
                        </ControlLabel>
                        <FormControl
                          type="text"
                          name="username"
                          autoComplete="username"
                          value={this.state.username}
                          onChange={event => this.handleUserNameChange(event)}
                        />{" "}
                        {this.state.usernameError}
                      </FormGroup>
                      <FormGroup>
                        <ControlLabel>
                          Email:
                          <span className="star">*</span>
                        </ControlLabel>
                        <FormControl
                          type="text"
                          name="email"
                          autoComplete="email"
                          value={this.state.email}
                          onChange={event => this.handleEmailChange(event)}
                        />{" "}
                        {this.state.emailError}
                      </FormGroup>
                      <FormGroup>
                        <ControlLabel>
                          Rol:
                          <span className="star">*</span>
                        </ControlLabel>
                        <Select
                          placeholder="Rol"
                          closeOnSelect
                          name="multipleSelect"
                          value={this.state.rolesSelected[0]}
                          options={this.state.rolesList}
                          onChange={event => this.handleRolesChange(event)}
                        />
                        {this.state.rolesError}
                      </FormGroup>
                      {this.state.rolesSelected[0] === '6' &&
                        <div>
                          <FormGroup>
                            <ControlLabel>
                              Proyecto:
                              <span className="star">*</span>
                            </ControlLabel>
                            <Select
                              placeholder="Proyecto"
                              closeOnSelect
                              name="proyectSelect"
                              value={this.state.selectedProject}
                              options={this.state.proyectos}
                              onChange={event => this.handleProyectChange(event)}
                            />
                            {this.state.proyectosError}
                          </FormGroup>
                        </div>
                      }
                      <FormGroup>
                        <ControlLabel>
                          Contraseña:
                          <span className="star">
                            {this.action === "edit" ? "" : "*"}
                          </span>
                        </ControlLabel>
                        <FormControl
                          type="password"
                          name="password"
                          autoComplete="current-password"
                          onChange={event => this.handlePasswordChange(event)}
                        />{" "}
                        {this.state.passwordError}
                      </FormGroup>
                      <FormGroup>
                        <ControlLabel>
                          Confirme contraseña:
                          <span className="star">
                            {this.action === "edit" ? "" : "*"}
                          </span>
                        </ControlLabel>
                        <FormControl
                          type="password"
                          name="cfpassword"
                          autoComplete="current-password"
                          onChange={event => this.handleCfPasswordChange(event)}
                        />{" "}
                        {this.state.cfpasswordError}
                      </FormGroup>
                      <div className="category">
                        <span className="star">*</span>
                        Campos requeridos
                      </div>
                      <div className="category">
                        <span>
                          {this.action === "edit"
                            ? '  Deje vacíos los campos de "Contraseña" si no desea cambiarla'
                            : ""}
                        </span>
                      </div>
                    </div>
                  }
                  legend={
                    <div style={{ textAlign: "right" }} title={disabledButton ? 'Uno o mas campos contienen errores o están vacios!' : null}>
                      <Button
                        bsStyle="info"
                        fill={true}
                        wd={true}
                        onClick={this.handleRegisterSubmit.bind(this)}
                        disabled={disabledButton}
                      >
                        Guardar cambios
                      </Button>
                    </div>
                  }
                />
              </form>
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}
export default Edit;



// WEBPACK FOOTER //
// ./src/views/UsersManagement/Edit.jsx